













































































































































import { Component, Vue } from "vue-property-decorator";
@Component
export default class Esitamition extends Vue {
  range() {
    var chartDom = document.getElementById("range");
    var myChart = (this as any).$echarts.init(chartDom);
    // let decline = res.fullChargedDrivingMile;
    // let rateMileage = res.rateMileage;
    // let comprehensiveEvaluate = res.comprehensiveEvaluate;
    let positionLeft = 1,
      max = 100 + 2 * positionLeft;
    var option = {
      grid: {
        top: "0%",
        left: "0%",
        right: "0%",
        bottom: "0%",
      },
      xAxis: {
        type: "value",
        max: 465,
        splitLine: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
      yAxis: {
        type: "category",
        inverse: false,
        data: [],
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
      },
      series: [
        {
          //间距
          type: "bar",
          barWidth: 20,
          stack: "b",
          legendHoverLink: false,
          itemStyle: {
            normal: {
              color: "rgba(0,0,0,0)",
            },
          },

          data: [positionLeft],
        },
        {
          name: "XXX",
          type: "pictorialBar",
          // symbol:
          //   "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAhNJREFUeNq0llsoLVEcxme27ZJEPLimXJI4yaMQxZOkePN0IukQdZIXOiFFSrnkQUnigTydDkleSOLxpJRc6qBc6uSE3G8P+P71zWns9phlX776tWdmrzXfrFlrffPXt19fNQUlglLwBTjBM6/L8R1YA4vg6aOb6DZmOeAbOAYzYBO8uLQJA8V8mL9gCFx+xiwIdIFbMMhfFaWBFvALLKiYRYNuMAB2Nc9UD4I5yv9yuDSK4khavTASjYBD0G5lpoM+voYLzXvNglNQ4c6sBvwEJ5rvNArKQKTZLATkuptUH6gHNJvNKsGk5h8dcGQhhlkeWNX8J3ljJQ6mwCNQiZJkMAfuObdtIECh3wooEKMUsKfQIRQsgySeJ3DjSwB02PSVhwuUkcUwZuxUbjIy6zu3ja0cXImPCm3jLK5H8B5KZtdMDjutWVxfBw8K/XUH5ytFofFv16yDrkCD4orUZYGcc95U1ATmQRGNphUTRwZz5OTJDV+lSiYukc9IFte8sanlCav8tKHFIwtsG2YbIAOE+8HsKwP+Xer3cpP6UrEg3wh4s9k+V1ydj4wkcfrBD6sv9RQbVXtpJEXQMOgEZ1ZmGssC46sd5oFRNssCmZI/5j+cFh0mQCYYY3KMK6REKmhkGVfrLgJ1hSK1kB9X0Q4T54zVUyyXdbxsWpYB/zwtUl33Szprw3BWv2K69ZGBWW8CDAD7MHTPqrySXgAAAABJRU5ErkJggg==",
          symbolSize: [20, 20],
          symbolOffset: [5, -3],
          z: 12,
          itemStyle: {
            normal: {
              color: "#48a878",
            },
          },
          data: [
            {
              value: 300,
              symbolPosition: "end",
            },
          ],
        },
        {
          //内
          type: "bar",
          barWidth: 20,
          stack: "b",
          // label: {
          //   normal: {
          //     show: true,
          //     position: "top",
          //     textStyle: {
          //       color: "#FF5B19 ",
          //     },
          //     rich: {
          //       img1: {
          //         backgroundColor: {
          //           image: img,
          //         },
          //       },
          //     },
          //     // formatter: function (e: any) {
          //     //   return (
          //     //     `${img1}` +
          //     //     ((e.value / (max - 2 * positionLeft)) * 100).toFixed(2) +
          //     //     "%"
          //     //   );
          //     // },
          //     formatter: function (param: any) {
          //       var res = "";
          //       res +=
          //         "\n {img1|}" +
          //         ((param.value / (max - 2 * positionLeft)) * 100).toFixed(0) +
          //         "%";
          //       return res;
          //     },
          //   },
          // },
          legendHoverLink: false,
          silent: true,
          itemStyle: {
            normal: {
              barBorderRadius: 30,
              color: new (this as any).$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {
                  offset: 0,
                  color: "#e4f2eb",
                },
                {
                  offset: 1,
                  color: "#7cc19f",
                },
              ]),
            },
          },

          data: [300],
        },
        {
          //框
          type: "bar",
          barWidth: 30,
          barGap: "-125%",
          label: {
            normal: {
              show: false,

              position: "right",
              textStyle: {
                color: "#000",
              },
            },
          },
          itemStyle: {
            normal: {
              barBorderRadius: 30,
              color: "rgba(0,0,0,0)", //底色
              borderWidth: 2,
              borderColor: "#89c7a8",
            },
          },
          data: [465],
          z: 5,
        },
      ],
    };
    myChart.setOption(option);
  }
  mounted() {
    this.range();
  }
}
